class ShowPasswordToggle {
    private readonly $passwordFormContainer: Element;
    private $fieldsToToggle: Element[] = [];

    constructor(document: Document) {
        this.$passwordFormContainer = document.querySelector(".fti_js_togglePasswordContainer")!!;
    }

    registerEventListeners() {
        const toggleLinks = this.$passwordFormContainer.querySelectorAll(".js_toggle_password_view");
        const passwordFields = this.$passwordFormContainer.querySelectorAll("input[type='password']");

        this.registerViewPasswordToggleEventListeners(toggleLinks);
        this.registerPasswordInputEventListeners(passwordFields);
    }

    private registerPasswordInputEventListeners(passwordFields: NodeListOf<Element>) {
        /*                                         */
        for (let i = 0; passwordFields[i]; i++) {
            const passwordField = passwordFields[i];
            this.$fieldsToToggle.push(passwordField);
        }
    }

    private registerViewPasswordToggleEventListeners(toggleLinks: NodeListOf<Element>) {
        /*                                         */
        for (let i = 0; toggleLinks[i]; i++) {
            const toggleLink = toggleLinks[i];
            toggleLink.addEventListener("click", (evt) => {
                this.handleViewPasswordToggleClick(evt);
            });
        }
    }

    private handleViewPasswordToggleClick(ev: Event) {
        ev.preventDefault();
        this.togglePasswordDisplay();
    }

    private togglePasswordDisplay() {
        for (const fieldToToggle of this.$fieldsToToggle) {
            const showPlainText = fieldToToggle.getAttribute("type") == "password";
            const newTypeAttribute = showPlainText ? "text" : "password";

            fieldToToggle.setAttribute("type", newTypeAttribute);
        }

        const toggleLinks = this.$passwordFormContainer!!.querySelectorAll(".toggle-password-text");
        for (let i = 0; toggleLinks[i]; i++) {
            const element = toggleLinks[i];
            if (element.classList.contains("invisible")) {
                element.classList.remove("invisible");
            } else {
                element.classList.add("invisible");
            }
        }
    }
}

export default ShowPasswordToggle;
